import { render, staticRenderFns } from "./newsTable.vue?vue&type=template&id=4d37368a&scoped=true"
import script from "./newsTable.vue?vue&type=script&lang=js"
export * from "./newsTable.vue?vue&type=script&lang=js"
import style0 from "./newsTable.vue?vue&type=style&index=0&id=4d37368a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37368a",
  null
  
)

export default component.exports